import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableSortLabel from '@mui/material/TableSortLabel'
import type { HeadCell, SortedHeadCells } from '../../types'
import type { Order } from './types'

const headCells: readonly HeadCell[] = [
  { id: 'org_name', label: 'Organization Name', hasSort: true },
  { id: 'city', label: 'City', hasSort: true },
  { id: 'state', label: 'State', hasSort: true },
  { id: 'initCommTask', label: 'Initiative', hasSort: true },
  { id: 'initiative_type', label: 'Type of Initiative' },
  { id: 'geo_scope', label: 'Geographic Scope', hasSort: true },
  { id: 'target', label: 'Liable Institution' },
  { id: 'focus', label: 'Focus Area' },
  { id: 'strategy', label: 'Strategy' },
  { id: 'stage', label: 'Stage' },
  { id: 'repair', label: 'Form of Repair' },
  { id: 'budget_amount', label: 'Budget' },
  { id: 'budget_date', label: 'Budget Date' },
  { id: 'value_amount', label: 'Value of Reparations' },
  { id: 'value_date', label: 'Value Date' },
]

interface TableHeaderProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof SortedHeadCells
  ) => void
  order: Order
  orderBy: string
}

const TableHeader = (props: TableHeaderProps) => {
  const { order, orderBy, onRequestSort } = props
  const createSortHandler =
    (property: keyof SortedHeadCells) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property)
    }

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.label}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.hasSort ? (
              <TableSortLabel
                active={true} // make always active so that arrow shows up
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(
                  headCell.id as keyof SortedHeadCells
                )}
                sx={{
                  '& .MuiTableSortLabel-icon': {
                    color:
                      orderBy === headCell.id
                        ? '#629A41 !important'
                        : 'rgba(0, 0, 0, 0.3) !important',
                    '&:hover': {
                      color: '#629A41 !important',
                    },
                  },
                }}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
export default TableHeader
